<template>
  <article class="info-section elr-container-full">
    <div class="elr-row">
      <div class="elr-col-full">
        <div class="info-section-header">
          <InfoSectionHeading>
            {{(model === 'year') ? item.year_made : capitalize(item.name)}}
          </InfoSectionHeading>
          <slot name="info" />
          <p class="info-section-description">{{item.description}}</p>
          <ItemButtons
            @onRemoveItem="removeItem"
            :model="model"
            :item="item"
            :user="currentUser"
          />
          <ItemNavigation
            :prev="prev"
            :next="next"
            :model="model"
          />
        </div>
      </div>
    </div>
    <!-- <div class="elr-row">
      <div class="elr-col-full"> -->
        <list-item-grid :status="status">
          <slot />
        </list-item-grid>
      <!-- </div>
    </div> -->
  </article>
</template>

<script>
import { mapState } from 'vuex';
import { capitalize, infiniteScroll, showPrompt } from '../../utils/helpers';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import ListItemGrid from '../../components/ListItemGrid/ListItemGrid';
import ItemButtons from '../../components/ItemButtons/ItemButtons';
import ItemNavigation from '../../components/ItemNavigation/ItemNavigation';

export default {
  name: 'Item',
  props: {
    status: {
      type: String,
      default: 'loading',
    },
    model: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    prev: {
      type: Object,
      default: () => ({}),
    },
    next: {
      type: Object,
      default: () => ({}),
    },
    nextUrl: {
      type: String
    }
  },
  mounted() {
    infiniteScroll(() => {
      if (this.nextUrl && this.status !== 'loading') {
        this.$emit('onFetchMore', {
          url: this.nextUrl,
        });
      }
    });
  },
  components: {
    InfoSectionHeading,
    ItemButtons,
    ItemNavigation,
    ListItemGrid
  },
  computed: {
    ...mapState('currentUser', ['currentUser', 'authenticated']),
  },
  methods: {
    capitalize,
    removeItem() {
      showPrompt();

      this.$emit('onRemoveItem', {
        slug: this.item.slug
      });
    }
  }
};
</script>
